

export default class State {
    name: String
    code: String
}